export type ChipType = {
  kind: string;
  icon: string;
};

export const ChipTypeConstant = {
  DEFAULT: {
    kind: "default",
    icon: "none"
  } as const,
  ERROR: {
    kind: "error",
    icon: "warning-red"
  } as const,
  NOTICE: {
    kind: "notice",
    icon: "warning-blue"
  } as const,
  EXAMPLE_PROMPT: {
    kind: "example-prompt",
    icon: "none"
  } as const,
  DOCUMENT: {
    kind: "document",
    icon: "document"
  } as const,
  ANALYZE: {
    kind: "analyze",
    icon: "analyze"
  } as const,
  WARNING: {
    kind: "warning",
    icon: "warning"
  } as const,
  BETA: {
    kind: "beta",
    icon: "none"
  } as const,
  INFO: {
    kind: "info",
    icon: "none"
  } as const
};

export type ChipTypeConstantType = typeof ChipTypeConstant[keyof typeof ChipTypeConstant] | ChipType;
